import React, {Component} from "react";
import { Line } from 'react-chartjs-2';
import ReactToPrint from "react-to-print";
import FeatherIcon from 'feather-icons-react';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, Title, CategoryScale, Legend, Tooltip } from 'chart.js';
import UserIdentity from "../../users/UserIdentity";
import Headerpdf from "../../users/Headerpdf";
import { getThemeColor } from "../../../theme/branding";

ChartJS.register(CategoryScale, LineElement, PointElement, LinearScale, Title, Legend, Tooltip);

const createDataset = (data, color = getThemeColor()) => ({
  label: 'Données',
  fill: true,
  tension: 0.35,
  backgroundColor: `${color}1f`,
  borderColor: color,
  pointBackgroundColor: color,
  pointBorderColor: '#fff',
  pointHoverBackgroundColor: '#fff',
  pointHoverBorderColor: color,
  borderWidth: 2,
  data
});

class StudentLine extends Component{

    state = {
        labels: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
        data: [],
        datasets: [createDataset([47, 35, 66, 52, 33, 44, 20, 66, 12, 22, 44, 59])]
      }

      componentDidMount(){
        window.addEventListener("evivesoma:theme", this.handleThemeChange);

        if(this.props.data)
        {
          this.setState({
              data : this.props.data,
              datasets: [createDataset(this.props.data)]
          })
        }

        if(this.props.labels)
        {
          this.setState({
            labels : this.props.labels
          })
        }
      }

      componentWillUnmount(){
        window.removeEventListener("evivesoma:theme", this.handleThemeChange);
      }

      handleThemeChange = (event) => {
        const color = event.detail || getThemeColor();
        this.setState((state) => ({
          datasets: state.datasets.map((dataset) => createDataset(dataset.data, color))
        }));
      }

    render(){
        
        return(
        <div>
          <div className="text-end">
              <ReactToPrint
                  trigger={() => (
                    <button
                      className="btn btn-sm btn-primary d-inline-flex align-items-center gap-2 rounded-3 px-3"
                      type="button"
                      title="Imprimer le graphique"
                    >
                      <FeatherIcon icon="printer" size="17" />
                      <span>Imprimer</span>
                    </button>
                  )}
                  content={() =>  this.componentRef}
              />
          </div>
          <div ref={el => (this.componentRef = el)}>
            <div className="m-2 ml-4">
              <Headerpdf />
            {
               <UserIdentity matricule ={this.props.matricule} name={this.props.name} classe={this.props.classe} title={this.props.title} /> 
            }
          {
            this.state.data.length > 0 && (
            <Line
                className="col-12"
                data={this.state}
                options={{
                  plugins: {
                    title: {
                      display: true,
                      // text: 'Données',
                      // font: { size: 20 }
                    },
                    legend: {
                      display: true,
                      // position: 'right'
                    }
                  }
                }}
                />
              )
            } 
            </div>
          </div>
        </div>
        )
    }
}
export default StudentLine;
